import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../../../context/app/context";
import EndPoints from "../../../services/end-points";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import PaymentPointContext from "../../../context/payment-point/context";
import { IPoint } from "../../../models/point/response";
import { useLocation } from "react-router-dom";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";

interface IProps { }

const PaymentPointFilter: React.FC<IProps> = () => {
    const { t } = useTranslation();
    const { actions, query } = useContext(PaymentPointContext);
    const { direction } = useContext(AppContext);
    const [point, setPoint] = useState<IPoint[]>([]);
    const [pointLoading, setPointLoading] = useState(true);

    const location = useLocation();
    const [initialValues, setInitialValues] = useState<Record<string, any>>({});

    useEffect(() => {
        const filters = getFiltersFromURL();

        const initialValuesObj = {};
        filters.forEach((f) => {
            initialValuesObj[f.name] = f.value;
        });

        setInitialValues(initialValuesObj);
    }, [location.search]);
    useEffect(() => {
        const getPoint = async () => {
            try {
                const { data } = await EndPoints.point.getAllPoints({
                    light: true,
                    perPage: -1,
                });
                setPoint(data.data);
                setPointLoading(false);
            } catch (error) {
            } finally {
                setPointLoading(false);
            }
        };
        getPoint();
    }, [direction]);

    return (
        <Form
            formId="payment-point-filter"
            defaultValues={initialValues}
            onSubmit={(data) => {
                const keyword = getKeywordFromURL();
                const filter: any = {
                    page: INITIAL_PAGE,
                    perPage: query?.perPage,
                    keyword: keyword,
                    filters: [
                        data?.collectionPointId
                            ? {
                                name: "collectionPointId",
                                value: data.collectionPointId,
                                operation: "eq",
                            }
                            : undefined,
                        data?.createdAt != undefined &&
                            data.createdAt[0] != ""
                            ? {
                                name: "createdAt",
                                value: data.createdAt[0],
                                operation: "gte",
                            }
                            : undefined,
                        data?.createdAt != undefined &&
                            data.createdAt[1] != ""
                            ? {
                                name: "createdAt",
                                value: data.createdAt[1],
                                operation: "lte",
                            }
                            : undefined,
                    ].filter((f) => f),
                };
                const queryString = filtersToQueryString(filter.filters);
                window.history.replaceState(null, "", `?${queryString}`);
                addSearchToURL(keyword);
                actions.setQuery(filter);
            }}
        >
            <Row justify={"start"} gutter={[10, 0]}>
                <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    <FieldBuilder
                        name="collectionPointId"
                        label={`${t("point")}`}
                        width="large"
                        input={{
                            type: "select",
                            allowSearch: true,
                            loading: pointLoading,
                            options: point.map((p, index) => {
                                return {
                                    label: p.name,
                                    value: p.id,
                                };
                            }),
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    <FieldBuilder
                        name="createdAt"
                        label={`${t("created_at")}`}
                        input={{ type: "range-picker" }}
                        rules={{ required: false }}
                    />
                </Col>
            </Row>
        </Form>
    );
};

export default PaymentPointFilter;
